module.exports = __webpack_public_path__ + "static/media/companynewsImg1.bded36fe.jpg";